"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerSelect = exports.BmSelect = void 0;

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<slot></slot>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tcontain: content;\n\t\tposition: relative;\n\t\tmax-width: 270px;\n\t\tmin-width: 50px;\n\t\twidth: 100%;\n\t\tfont-size: 14px;\n\t\tbackground-color: #fff;\n\t}\n\n\t:host([hidden]) {\n\t\tdisplay: none;\n\t}\n\t:host([focused]) {\n\t\toutline: 0;\n\t\tbox-shadow: none;\n\t}\n\n\t.select-wrapper {\n\t\tflex-grow: 1;\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\talign-items: baseline;\n\t\toverflow: hidden;\n\t\tbackground-color: #fff;\n\t}\n\t:host::after {\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\tbackground: url(data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjMjEyMTIxIiBkPSJNNyAxMGw1IDUgNS01eiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);\n\t\tfont-size: 1.65em;\n\t\tfont-family: arial;\n\t\toverflow: hidden;\n\t\theight: 1em;\n\t\twidth: 1em;\n\t\tright: 0.2em;\n\t\ttop: 0.1em;\n\t\tz-index: 1;\n\t}\n\n\t:host > * {\n\t\tflex-grow: 1;\n\t}\n\n\t::slotted(select) {\n\t\ttransition: border-color ease-in-out 0.2s;\n\t\tborder: 1px solid #b2b2b8;\n\t\tborder-radius: 0;\n\t\theight: 30px;\n\t\tcolor: #37383d;\n\t\tbackground-color: transparent;\n\t\tbox-shadow: none;\n\t\tpadding: 0px 12px;\n\t\tfont-size: 14px;\n\t\tline-height: 26px;\n\t\tz-index: 2;\n\t\tflex-grow: 1;\n\t\t-webkit-appearance: none;\n\t\t-moz-appearance: none;\n\t\tappearance: none;\n\t\ttext-indent: 0.01px;\n\t}\n\t::slotted(select:focus) {\n\t\toutline: 0;\n\t\tbox-shadow: none;\n\t\tborder-color: #3c3e45;\n\t}\n\t::slotted(select[disabled]) {\n\t\tcolor: #606169;\n\t\tbackground-color: #f4f5f7;\n\t\tborder-color: #b2b2b8;\n\t}\n\t::slotted(select[readonly]) {\n\t\tcolor: #37383d;\n\t\tbackground-color: #fff;\n\t\tborder-color: #fff;\n\t\tfont-weight: 700;\n\t}\n\t::slotted(select.invalid) {\n\t\tborder-color: #dc0a0a;\n\t\tborder-color: var(--danger, #dc0a0a) !important;\n\t}\n\t::slotted(*) {\n\t\tflex-grow: 1;\n\t\twidth: 100%;\n\t}\n\n\t:host([large])::after {\n\t\ttop: 0.34em;\n\t}\n\n\t:host([large]) ::slotted(select) {\n\t\theight: 40px;\n\t\tpadding: 6px 23px;\n\t}\n\n\t/*\n\t\tThis is because is the only way to hide the select carret on IE11\n\t\tTODO: Remove when IE11 is gone\n\t*/\n\t::slotted(select::-ms-expand) {\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmSelect = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmSelect, _BlueElement);

  var _super = (0, _createSuper2.default)(BmSelect);

  (0, _createClass2.default)(BmSelect, null, [{
    key: "is",
    get: function get() {
      return 'bm-select';
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);

  function BmSelect() {
    var _context, _context2, _context3;

    var _this;

    (0, _classCallCheck2.default)(this, BmSelect);
    _this = _super.call(this);
    _this.onSlotChange = (0, _bind.default)(_context = _this.onSlotChange).call(_context, (0, _assertThisInitialized2.default)(_this));
    _this.onSelectFocus = (0, _bind.default)(_context2 = _this.onSelectFocus).call(_context2, (0, _assertThisInitialized2.default)(_this));
    _this.onSelectBlur = (0, _bind.default)(_context3 = _this.onSelectBlur).call(_context3, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmSelect, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var slot;
        return _regenerator.default.wrap(function _callee$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                (0, _get2.default)((0, _getPrototypeOf2.default)(BmSelect.prototype), "connectedCallback", this).call(this);

                if (this.shadowRoot) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", this.dispatchError('<bm-select> required shadow DOM'));

              case 3:
                _context4.next = 5;
                return this.updateComplete;

              case 5:
                slot = this.shadowRoot.querySelector('slot');

                if (!slot) {
                  _context4.next = 12;
                  break;
                }

                slot.removeEventListener('slotchange', this.onSlotChange);
                slot.addEventListener('slotchange', this.onSlotChange);
                this.onSlotChange();
                _context4.next = 13;
                break;

              case 12:
                return _context4.abrupt("return", this.dispatchError('<slot> not found'));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "dispatchError",
    value: function dispatchError(error) {
      this.dispatchEvent(new ErrorEvent('error', {
        message: error instanceof Error ? error.message : error
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject2());
    }
  }, {
    key: "onSlotChange",
    value: function onSlotChange() {
      if (!this.shadowRoot) {
        return this.dispatchError('<bm-select> required shadow DOM');
      }

      var slot = this.shadowRoot.querySelector('slot');

      if (slot) {
        var _context5;

        var select = (0, _find.default)(_context5 = slot.assignedNodes()).call(_context5, function (element) {
          return element.nodeName === 'SELECT';
        });

        if (select) {
          select.removeEventListener('focus', this.onSelectFocus);
          select.addEventListener('focus', this.onSelectFocus);
          select.removeEventListener('blur', this.onSelectBlur);
          select.addEventListener('blur', this.onSelectBlur);
        } else {
          return this.dispatchError('<select> not found');
        }
      } else {
        return this.dispatchError('<slot> not found');
      }
    }
  }, {
    key: "onSelectFocus",
    value: function onSelectFocus() {
      this.setAttribute('focused', '');
    }
  }, {
    key: "onSelectBlur",
    value: function onSelectBlur() {
      this.removeAttribute('focused');
    }
  }]);
  return BmSelect;
}(_element.BlueElement);

exports.BmSelect = BmSelect;

var registerSelect = function registerSelect() {
  return (0, _element.register)(BmSelect);
};

exports.registerSelect = registerSelect;
